export default __webpack_public_path__ + "static/media/milestone 850.d8542e93.svg";